<template>
  <component
    :is="isActionTrigger(link) ? 'button' : 'a'"
    :open-new-tab="openNewTab"
    :style="$attrs.style"
    :class="[
      'text-center rounded-lg transition shadow-none hover:shadow-inner shadow-teal-900 ease-in-out',
      { 'cursor-not-allowed': disabled },
      twMerge(
        color === 'primary' &&
          variant === 'contained' &&
          'bg-teal-900 text-white hover:bg-teal-900',
        color === 'primary' &&
          disabled &&
          'bg-gray-200 hover:bg-gray-200 text-gray-500',
        variant === 'contained' && 'px-4 py-2 rounded-lg',
        color === 'primary' &&
          variant === 'outlined' &&
          'border border-teal-900 text-teal-900 hover:bg-teal-900 hover:text-white py-2',
        variant === 'text' &&
          ' underline hover:shadow-none font-semibold hover:text-teal-900',
        color === 'secondary' &&
          variant === 'contained' &&
          'bg-primary-light text-teal-900 hover:bg-teal-900 hover:text-white',
        color === 'tertiary' &&
          variant === 'contained' &&
          'bg-gray-50 text-gray-800 hover:bg-gray-100',
        color === 'translucent' && variant === 'contained' && 'bg-white/50',
        (color === 'primary-inverted' || color === 'primary_inverted') &&
          variant === 'contained' &&
          'bg-white text-teal-900 hover:bg-gray-50',
        selected && 'bg-teal-50 text-primary border-primary',
        $attrs.class
      ),
    ]"
    :disabled="disabled"
    :href="link"
    :target="openNewTab ? '_blank' : '_self'"
  >
    <span v-if="showSpinnerLeft" class="loader"></span>
    <!--@slot Use this slot to place content inside the button.-->
    <slot />
  </component>
</template>
<script setup lang="ts">
import { twMerge } from 'tailwind-merge'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(
  defineProps<{
    color?: string
    variant?: string
    disabled?: boolean
    selected?: boolean
    link?: string
    openNewTab?: boolean
    showSpinnerLeft?: boolean
  }>(),
  {
    color: 'primary',
    variant: 'contained',
    disabled: false,
    selected: false,
    link: '',
    openNewTab: false,
    showSpinnerLeft: false,
  }
)
const isActionTrigger = (uri: string | undefined) =>
  !(uri?.includes('/') || uri?.includes(':'))
</script>
